import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'twoColumnGroupBy'
})
export class TwoColumnGroupByPipe implements PipeTransform {

  transform(collection: Array<any>, property: Array<any>): Array<any> {

    if (!collection) {
        return null;
    }
    var notNull = _.negate(_.isNull);
    const groupedCollection = _.groupBy(collection, function(note) {
                      return _.find(_.pick(note, property), notNull);
    });
    return Object.keys(groupedCollection).map(key => ({ key, value: groupedCollection[key] }));
}
}
